<ng-container *transloco="let t; prefix: scope">
  <strong class="shrink-0 text-left">{{ t('quickLinks.title') }}</strong>
  <div
    class="grid shrink transform grid-cols-1 gap-2 transition-all delay-150 md:grow md:grid-cols-2 lg:shrink lg:grid-cols-4"
    [class.lg:!grid-cols-2]="isMultiColumn"
  >
    @if (links) {
      <rma-footer-location-links [locationLinks]="links" [isIndividual]="true" [isMultiColumn]="isMultiColumn" verticalType="sales" />
      <rma-footer-location-links [locationLinks]="links" [isMultiColumn]="isMultiColumn" verticalType="sales" />

      @if (hasLeasing) {
        <rma-footer-location-links [locationLinks]="links" verticalType="leasing" />
      }
      @if (hasFinance) {
        <rma-footer-location-links [locationLinks]="links" [isIndividual]="true" verticalType="finance" />
      }
    }
  </div>
</ng-container>
